import Button from 'components/shared/Buttons/BaseButton';
import { BudgetBarGraph } from './BudgetBarGraph';
import type { BudgetResult } from './types';

interface BudgetCalculatorResultProps {
  result: BudgetResult;
  onEdit: () => void;
  onStartOver: () => void;
}

export const BudgetCalculatorResult = ({ result, onEdit, onStartOver }: BudgetCalculatorResultProps) => (
  <div className="mt-6 flex flex-col gap-6">
    <BudgetBarGraph result={result} />

    <div className="flex flex-col gap-4 sm:flex-row">
      <Button type="button" onClick={onEdit}>
        Edit amounts
      </Button>
      <Button type="button" variant="outline" onClick={onStartOver}>
        Start over
      </Button>
    </div>
  </div>
);
